export interface AccentRun {
  text: string;
  accent: boolean;
  /** Offset in the source string; a stable key for rendering. */
  start: number;
}

// `\S…\S` keeps `2 * 3` and `a * b` literal; `[^*\n]` stops a stray asterisk swallowing a paragraph.
const ACCENT = /\*(\S(?:[^*\n]*\S)?)\*/g;

export function parseAccentRuns(value: string): AccentRun[] {
  const runs: AccentRun[] = [];
  let last = 0;

  for (const match of value.matchAll(ACCENT)) {
    if (match.index > last) {
      runs.push({ text: value.slice(last, match.index), accent: false, start: last });
    }
    runs.push({ text: match[1], accent: true, start: match.index });
    last = match.index + match[0].length;
  }
  if (last < value.length) runs.push({ text: value.slice(last), accent: false, start: last });

  return runs;
}
